import { useEffect, useState, useRef } from 'react';
import { useLogos } from '../Hooks/useLogos';
import { useToken } from '../contexts/TokenContext';
import { CONFIG_STORAGE_KEY, migrateToSessionStorage } from '@/services/tenantService';
import { jwtDecode } from 'jwt-decode';

export const GAInit = () => {
  const { clientId } = useLogos();
  const { idToken, tokenVersion } = useToken();
  const [config, setConfig] = useState(null);
  const gaInitialized = useRef(false);
  const loginEventSent = useRef(false);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        migrateToSessionStorage();
        const configStorage = sessionStorage?.getItem(CONFIG_STORAGE_KEY) || "{}";
        const configData = JSON.parse(configStorage); 
        setConfig(configData);
      } catch (error) {
        console.error('Error loading config:', error);
      }
    };

    loadConfig();
  }, [clientId]);

  useEffect(() => {
    if (!config?.FEATURE_FLAGS?.GA_ID) return;

    if (!gaInitialized.current) {
      // Inicializa o Google Analytics
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${config.FEATURE_FLAGS.GA_ID}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', config.FEATURE_FLAGS.GA_ID, {
        send_page_view: false // Desabilita o pageview automático para controlar manualmente via GAPageTracker
      });

      gaInitialized.current = true;
    }

    // Identifica o usuário se tiver token
    if (idToken && window.gtag && !loginEventSent.current) {
      try {
        const decodedToken = jwtDecode(idToken);
        const participantId = decodedToken['custom:participantId'];
        if (participantId) {
          window.gtag('config', config.FEATURE_FLAGS.GA_ID, {
            user_id: participantId,
            custom_map: {
              participant_id: 'participant_id'
            },
            send_page_view: false
          });
          
          // Envia evento de login apenas uma vez
          window.gtag('event', 'login', {
            method: 'jwt',
            participant_id: participantId
          });
          
          loginEventSent.current = true;
        }
      } catch (error) {
        console.error('Erro ao decodificar token para GA:', error);
      }
    }
  }, [config, idToken, tokenVersion]);

  return null;
}; 
